/**
 * Takes the answer object and expands it into multiple answers consisting of
 * labelled answers with the corresponding percentage, and a comma-joined string
 * of all the percentages for the answer to questionName. Used in the SET and MERGE actions.
 *
 * @param questionName - The name of the question
 * @param objectAnswer - The object containing label->percentage pairs
 * @returns Record with both individual bracketed answers and parent comma-separated answer
 */
export const expandPercentageObjectAnswer = (
  questionName: string,
  objectAnswer: unknown,
): Record<string, string> => {
  if (
    objectAnswer &&
    typeof objectAnswer === "object" &&
    !Array.isArray(objectAnswer)
  ) {
    const expanded: Record<string, string> = {};

    // Convert object to bracketed answers (labels come in lower)
    Object.entries(objectAnswer as Record<string, unknown>).forEach(
      ([label, value]) => {
        expanded[`${questionName}[${label.toLowerCase()}]`] = String(value);
      },
    );

    // Create pseudo-answer (comma-separated format for validation compatibility)
    const values = Object.values(objectAnswer as Record<string, unknown>);
    expanded[questionName] = values.join(",");

    return expanded;
  }

  return {};
};
